
export interface MeshLocation {
  id: number;
  name: string;
  lat: number;
  lng: number;
  status: 'active' | 'down';
  storage: string;
  securityLevel: string;
  connections: number;
  lastUpdated: string;
  encryptionType: string;
  region: string;
  uptime: string;
}

export const meshLocations: MeshLocation[] = [
  { 
    id: 1, 
    name: "North America Data Center", 
    lat: 40.7128, 
    lng: -74.0060, 
    status: "active", 
    storage: "250TB",
    securityLevel: "High",
    connections: 24,
    lastUpdated: "2 minutes ago",
    encryptionType: "CRYSTALS-Kyber",
    region: "North America",
    uptime: "99.98%"
  },
  { 
    id: 2, 
    name: "Europe Data Center", 
    lat: 48.8566, 
    lng: 2.3522, 
    status: "active", 
    storage: "180TB",
    securityLevel: "High",
    connections: 18,
    lastUpdated: "5 minutes ago",
    encryptionType: "CRYSTALS-Kyber",
    region: "Europe",
    uptime: "99.95%" 
  },
  { 
    id: 3, 
    name: "Asia Data Center", 
    lat: 35.6762, 
    lng: 139.6503, 
    status: "down", 
    storage: "200TB",
    securityLevel: "High",
    connections: 0,
    lastUpdated: "32 minutes ago",
    encryptionType: "NTRU",
    region: "Asia",
    uptime: "98.72%"
  },
  { 
    id: 4, 
    name: "South America Data Center", 
    lat: -23.5505, 
    lng: -46.6333, 
    status: "active", 
    storage: "120TB",
    securityLevel: "Medium",
    connections: 12,
    lastUpdated: "8 minutes ago",
    encryptionType: "AES-256-GCM",
    region: "South America",
    uptime: "99.87%"
  },
  { 
    id: 5, 
    name: "Australia Data Center", 
    lat: -33.8688, 
    lng: 151.2093, 
    status: "down", 
    storage: "85TB",
    securityLevel: "Medium",
    connections: 0,
    lastUpdated: "45 minutes ago",
    encryptionType: "AES-256-GCM",
    region: "Oceania",
    uptime: "97.23%"
  },
  { 
    id: 6, 
    name: "Africa Data Center", 
    lat: -33.9249, 
    lng: 18.4241, 
    status: "active", 
    storage: "75TB",
    securityLevel: "Medium",
    connections: 8,
    lastUpdated: "12 minutes ago",
    encryptionType: "SIKE",
    region: "Africa",
    uptime: "99.45%"
  },
];
